
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { google } from 'google-maps';

@Component
export default class GoogleMapRecordedPath extends Vue {
  @Prop() googleApi!: google;
  @Prop() map!: google.maps.Map<HTMLDivElement>;
  @Prop() polyline!: google.maps.PolylineOptions;

  mapPolyLine = null as google.maps.Polyline | null;

  @Watch('polyline')
  onLineChange(val: google.maps.PolylineOptions, oldVal: google.maps.PolylineOptions) {
    const valPos = val.path as Array<google.maps.LatLng>;
    const oldValPos = oldVal.path as Array<google.maps.LatLng>;
    if (this.mapPolyLine && valPos.length != oldValPos.length) {
      this.mapPolyLine.setPath(this.polyline.path as Array<google.maps.LatLng>);
      this.mapPolyLine.setVisible(true);
    }
  }

  mounted() {
    this.mapPolyLine = new this.googleApi.maps.Polyline({
      path: this.polyline.path,
      map: this.map,
      strokeColor: this.polyline.strokeColor,
      visible: this.polyline.visible
    });
  }

  destroyed() {
    this.mapPolyLine?.setMap(null);
  }
}
